import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import NotificationsSidebarViewModel from '../NotificationsSidebarViewModel'
import Icon from 'components/Icon'
import { Link } from 'react-router-dom'
import styles from './NotificationsSidebarMenu.sass'
import link from 'infra/link'

interface Props {
  vm: NotificationsSidebarViewModel
}

export default observer(function NotificationsSidebarMenu({ vm }: Props) {
  return (
    <div className={cx(styles.root)} data-test="Menu">
      <div className={styles.sideActions}>
        <SideAction title="Close">
          <Icon name="back" onClick={vm.showing.disable} />
        </SideAction>
      </div>
      <div className={styles.divider} />
      <div className={styles.sideActions}>
        <SideAction
          data-test="Prefs"
          title="Notification Preferences"
          to={link.profileNotifications()}
          onClick={vm.showing.disable}
        >
          <Icon name="settings" />
        </SideAction>
      </div>
    </div>
  )
})

interface SideActionProps {
  children: React.ReactNode
  to?: string
  title?: string
  onClick?: () => unknown
}

const SideAction = ({
  children,
  to,
  onClick,
  title,
  ...rest
}: SideActionProps) => (
  <Link
    to={to || '#'}
    className={styles.sideAction}
    onClick={onClick}
    title={title}
    {...rest}
  >
    {children}
  </Link>
)
